/**
 * @file: AreaMetaData.
 * @authors: zhangkang.
 * @createDate: 2021/01/19.
 * @Description: 地域元数据
 */
import request from '@/utils/request'

/**
 * 城市信息列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function areaCityListGet(data) {
  return request({
    type: 'base',
    url: 'area/city/list/get',
    method: 'post',
    data
  })
}
/**
 * 国家信息列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function areaCountryListGet(data) {
  return request({
    type: 'base',
    url: 'area/country/list/get',
    method: 'post',
    data
  })
}
/**
 * 区县信息列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function areaDistrictListGet(data) {
  return request({
    type: 'base',
    url: 'area/district/list/get',
    method: 'post',
    data
  })
}
/**
 * 省信息列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function areaProvinceListGet(data) {
  return request({
    type: 'base',
    url: 'area/province/list/get',
    method: 'post',
    data
  })
}
/**
 * 道路信息列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function areaRoadListGet(data) {
  return request({
    type: 'base',
    url: 'area/road/list/get',
    method: 'post',
    data
  })
}
/**
 * 街道信息列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function areaStreetListGet(data) {
  return request({
    type: 'base',
    url: 'area/street/list/get',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/AreaMetaData.js